export const getHeaderOptions = () => {
    return {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    };
  };